import axios from "axios";

export const state = {
    appointments: [],
};

export const getters = {
    appointments: state => state.appointments,
};

export const mutations = {
    setAppointments(state, newValue) {
        state.appointments = newValue
    },
};

export const actions = {
    fetchAppointments({ commit }) {
        axios.get('/appointments').then(res => {
            commit('setAppointments', res.data.appointments);
        })
    },
};
